<template>
    <div id="">
        <swiper :options="swiperOption" ref="slideSwiper">
            <swiper-slide v-for="(file, index) in slideFiles" v-bind:key="index">
                <div class="slide-list">
                    <div class="swiper-zoom-container">
                        <img :src="file">
                    </div>
                </div>
                
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 이미지 슬라이드 swiper 컴포넌트(my learning lesson study - slide image swiper component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import learnApi from '@/api/learnApi.js'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
    data() {
        return {
            swiperOption: {
                zoom: true,
                direction: 'horizontal',
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
            },
            
            startIndex: 0,
            startTime: 0,
            // time: 5,

            enablNext: false

        }
    },
    props: ['slideFiles', 'last', 'recent', 'time', 'isAllPages', 'isScroll', 'isTimeline', 'isExpand', 'contentsType', 'setSlideNumber'],
    components: {
        swiper,
        swiperSlide
    },

    watch:{
        'enablNext' (val){
            this.slideSwiper.allowSlideNext	= val
        },
        'isAllPages' () {
            this.updateSwiper()
        },

        'isScroll' () {
            let direction = this.isScroll ? 'vertical' : 'horizontal'
            this.slideSwiper.changeDirection(direction)
        },

        'isTimeline' () {
            this.updateSwiper()
        },

        'isExpand' () {
            if (this.isExpend) {
                this.swiperOption.slidesPerView = 2
            }else {
                this.swiperOption.slidesPerView = 'auto'
            }
            this.updateSwiper()
        },

        'setSlideNumber' () {
            this.slideSwiper.slideTo(this.setSlideNumber-1)
        }
    },
    
    mounted() {
        
        this.slideSwiper = this.$refs.slideSwiper.swiper
        this.startIndex = this.recent ? this.recent - 1 : 0
        // this.slideSwiper.slideTo(this.startIndex)
        if (this.startIndex > 0 && this.startIndex < this.slideFiles.length-1 ) {
            this.$confirm({
                title: this.$t('173'), // '학습 중인 강의입니다.',
                content: this.$t('174') + '<br>' + this.$t('175'), //'이전에 학습했던 이력이 있습니다.<br>이어서 학습하시겠습니까?',
                accept: this.$t('177'), //'이어서 보기',
                cancel: this.$t('176'), //'처음부터 보기',
            }).then(() => {
                this.slideSwiper.slideTo(this.startIndex)
            }).catch(() => {
                this.slideSwiper.slideTo(0)
            })
        }else {
            this.slideSwiper.slideTo(0)
        }
        
        // 첫페이지 진도저장 실행(first load save progress)
        this.$emit('updateProgress')
        
        if (this.time > 0 && this.startIndex+1 > this.last ) {
            this.runTimer(this.startIndex)
        }else {
            this.enablNext = true
        }

        this.slideSwiper.allowSlideNext	= this.enablNext

        
        if (this.contentsType != 'PDF') {
            this.slideSwiper.on('slideChange', () => {
                let activeIndex = this.slideSwiper.activeIndex
                this.runTimer(activeIndex)
                this.$emit('updateProgress', activeIndex)
            })
        }

        this.slideSwiper.on('touchStart', () => {
            if (this.enablNext === true && (this.slideFiles.length-1) === this.slideSwiper.activeIndex) {
                this.$emit('updateEndedLesson', true)
            }else {
                this.$emit('updateEndedLesson', false)
            }
        })

        this.slideSwiper.on('imagesReady', () => { 
            // console.log('imagesReady!!');
            // this.$showLoading()
            this.$hideLoading()
         })

        
    },

    methods: {
        
        // 슬라이드 타이머 실행(Slide timer run)
        runTimer(activeIndex) {
            if (this.last < activeIndex+1) {
                this.enablNext = false
                this.startTime = this.time
                this.setTimer()
            }
        },


        // 슬라이드 타이머 동작(Slide timer action)
        setTimer() {
            this.startTime--
            if(this.startTime > 0) {
                setTimeout(() => {
                    console.log('this.startTime', this.startTime)
                    
                    this.setTimer()
                }, 1000);
            }else {
                this.enablNext = true
            }
        },

        //swiper UI 업데이트(update swiper UI)
        updateSwiper() {
            this.slideSwiper.update()
        }
    }


}
</script>